import StatusTag from "../../ui/StatusTag";
import { StatusTagProps } from "../../ui/StatusTag/statutsTagProps";
import { ResultTableProps } from "./resultTableType";
import * as Css from "./style";

export default function ResultTable({columns, results}: ResultTableProps) {
    return (
        <Css.ContainerResultTable>
            <Css.ContainerTableColumns>
                {columns.map(col => (
                    <Css.Column key={col.key}>
                        <Css.ColumnName>{col.label}</Css.ColumnName>
                        <div></div>
                        {results.map((row, idx) => (
                            <Css.ColumnValue className={col.key} key={idx}>
                                {col.key !== "status" && row[col.key]}
                                {col.key === "status" && <StatusTag status={row[col.key] as StatusTagProps["status"]}/>}
                            </Css.ColumnValue>
                        ))}
                    </Css.Column>
                ))}
            </Css.ContainerTableColumns>
        </Css.ContainerResultTable>
    );
}